import './ReassignDropdown.scss';

import { useSelector } from 'react-redux';

import { DefaultAvatar } from 'atoms/default-avatar';
import Dropdown from 'atoms/dropdown';
import { capitalizeFirstLetter } from 'util';

export function CustomAvatarContent({ selectedGroomer }) {
  return (
    <DefaultAvatar
      size="small"
      avatar={selectedGroomer?.links?.image?.desktop?.small}
      className="mr-10"
    />
  );
}

export default function ReassignDropdown({
  selectedGroomer,
  setSelectedGroomer,
}) {
  const { groomers } = useSelector((state) => state.groomers);
  const groomersDropdownOptions = groomers.map(({ user }) => ({
    name: capitalizeFirstLetter(user.firstName),
    links: user.links,
    uuid: user.uuid,
  }));

  const onSelectGroomer = (groomer) => {
    setSelectedGroomer(groomer);
  };

  return (
    <Dropdown
      id="reassign-dropdown"
      className="reassign-dropdown"
      variant="white"
      size="extra-small"
      shape="round"
      items={groomersDropdownOptions}
      value={capitalizeFirstLetter(selectedGroomer?.name)}
      CustomContent={() => CustomAvatarContent({ selectedGroomer })}
      onClick={onSelectGroomer}
    />
  );
}
